import React, { FC } from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import PlanDetailsPage from './PlanDetailsPage';
import ChooseLocationPage from './components/ChooseLocationPage/ChooseLocationPage';
import FloatPlanCreatePage from './components/FloatPlanCreatePage/FloatPlanCreatePage';
import PlanCompletePage from './components/PlanCompletePage/PlanCompletePage';
import EmergencyContactPage from './components/EmergencyContactPage/EmergencyContactPage';
import EmergencyContactsListPage from './components/EmergencyContactsListPage/EmergencyContactsListPage';
import SearchLocationPage from './components/SearchLocationPage/SearchLocationPage';
import UpdateMemberContactInformationPage from './components/UpdateMemberContactInformationPage/UpdateMemberContactInformationPage';

const ChooseLocationPageDefault = () => {
  const { pointId } = useParams<{ pointId: string }>();
  return <ChooseLocationPage pointId={pointId} />;
};

const EditContactPage = () => {
  const { contactId } = useParams<{ contactId?: string }>();
  return <EmergencyContactPage contactId={contactId} />;
};

const PlanFeature: FC = () => (
  <Switch>
    <Route path="/maps/plan" exact>
      <Redirect to="/maps/plan/create" />
    </Route>
    <Route path="/maps/plan/details" exact>
      <PlanDetailsPage />
    </Route>
    <Route path="/maps/plan/details/choose-location/:pointId">
      <ChooseLocationPageDefault />
    </Route>
    <Route path="/maps/plan/create" exact>
      <FloatPlanCreatePage />
    </Route>
    <Route path="/maps/plan/complete" exact>
      <PlanCompletePage />
    </Route>
    <Route path="/maps/plan/emergency-contacts" exact>
      <EmergencyContactsListPage />
    </Route>
    <Route path="/maps/plan/emergency-contacts/add" exact>
      <EmergencyContactPage />
    </Route>
    <Route path="/maps/plan/emergency-contacts/update-member" exact>
      <UpdateMemberContactInformationPage />
    </Route>
    <Route path="/maps/plan/emergency-contacts/edit/:contactId" exact>
      <EditContactPage />
    </Route>
    <Route path="/maps/plan/details/search-location/:pointId" exact>
      <SearchLocationPage />
    </Route>
  </Switch>
);

export default PlanFeature;
